import { IconAlertTriangle } from "@tabler/icons-react";

/** Amber marker for a signed-off platform weighing that failed the
 *  repeatability gate (signed off via explicit override). */
export function GateBadge({ label = "0.1% gate not met" }: { label?: string }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700 dark:text-amber-400">
      <IconAlertTriangle className="h-3 w-3" />
      {label}
    </span>
  );
}
